'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = ['M192.3 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z', 'M320.3 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-21.7 86.2c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8L142.5 307.4c33.9 18.3 72.6 28.6 113.8 28.6 88.8 0 166.4-48.2 207.9-120l27.7 16c-47 81.3-134.9 136-235.6 136-47 0-91.1-11.9-129.7-32.8l-96.4 168.8-7.9 13.9-27.8-15.9 7.9-13.9 97-169.8c-32.1-22.7-59-52.1-78.7-86.2l27.7-16c16.9 29.2 39.8 54.6 67 74.3L188 163.4c-17.1-17.3-27.6-41.1-27.6-67.4 0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l48.5 84.9c-8.5 6.5-17.5 12.3-26.9 17.3l-47.7-83.5zM510.2 488.1l7.9 13.9-27.8 15.9-7.9-13.9-72.6-127.1c9.4-5.1 18.5-10.7 27.3-16.8l73.1 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;